var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mb-08",class:_vm.column.type_generic === 0
        ? 'column-numeric-btn'
        : 'column-text-btn',attrs:{"outlined":!_vm.column.applied,"color":!_vm.column.applied ? 
      'false': _vm.column.type_generic === 0 ? 
        '#1bbab9' : 
        '#00A7FF',"rounded":"","width":_vm.pillWidth,"height":"24px"}},[_c('span',{staticClass:"ml-auto mr-auto"},[_vm._v(" "+_vm._s(_vm.column.column_name)+" ")]),_c('v-icon',{staticClass:"ml-auto",attrs:{"right":""},on:{"click":function($event){return _vm.$emit('deleteCol')}}},[_vm._v(" mdi-close-circle ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }